// @flow
import { get } from 'lodash';
import { reportError } from '@helpers/helpers';
import type { Action, ContextState, Dispatch } from '@types';
import { Api } from '../../../helpers';
import { router } from '../../../routes/router';

// Ajustes › Equipe (api: TeamsController, managers only): the members of the active clinic, who owns it, and what its
// owner's plan allows. The Painel de Controle's "Gerenciar Equipe".

// ------------------------------------
// Constants
// ------------------------------------
export const TEAM_LOADING = 'team.TEAM_LOADING';
export const TEAM_LOADED = 'team.TEAM_LOADED';
export const TEAM_FAILED = 'team.TEAM_FAILED';

// ------------------------------------
// Actions
// ------------------------------------
export const fetchTeam = () => (
  (dispatch: Dispatch, getState: Function) => {
    const clinicId = get(getState(), ['context', 'clinics', 'activeClinic', 'id'], null);
    dispatch({ type: TEAM_LOADING, clinicId });
    Api.get(router.getApiRoute('getTeam', {}), {
      success: (response) => {
        dispatch({ type: TEAM_LOADED, team: get(response, 'team'), clinicId });
      },
      error: (error) => {
        dispatch({ type: TEAM_FAILED, error: { message: error.message }, clinicId });
        dispatch(reportError(error));
      },
    });
  }
);

// The team of the active clinic, once loaded: what another clinic's answer says doesn't count
export const selectTeam = (state: Object): ?Object => {
  const team = get(state, ['context', 'team']);
  const activeClinicId = get(state, ['context', 'clinics', 'activeClinic', 'id'], null);
  return team && team.data && team.clinicId === activeClinicId ? team.data : null;
};

export const selectTeamLoading = (state: Object): boolean => Boolean(get(state, ['context', 'team', 'isLoading']));

// The member behind a professional's or a secretary's form (its route id is the Doctor's or the Secretary's)
export const selectTeamMember = (state: Object, roleType: 'Doctor' | 'Secretary', roleId: any): ?Object => {
  const members = get(selectTeam(state), 'members', []);
  return members.find(member => member.roleType === roleType && String(member.roleId) === String(roleId)) || null;
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function teamReducer(state: ContextState, action: Action): ContextState {
  switch (action.type) {
    case TEAM_LOADING:
      return state
        .setIn(['team', 'isLoading'], true)
        .setIn(['team', 'errors'], null);

    case TEAM_LOADED:
      return state
        .setIn(['team', 'isLoading'], false)
        .setIn(['team', 'clinicId'], action.clinicId)
        .setIn(['team', 'data'], action.team);

    case TEAM_FAILED:
      return state
        .setIn(['team', 'isLoading'], false)
        .setIn(['team', 'errors'], [action.error.message]);

    default:
      return state;
  }
}
